// Generated logos with transparent backgrounds
export const PTW_LOGO = "https://static.prod-images.emergentagent.com/jobs/4093f316-5b76-4f43-8631-ea3db1f19db5/images/c246b30d2553dd81ef53765d58716aa475cdfb4c918ee17ddeefb4d1ef2b4fab.png";

export const TRAVIS_LOGO = "https://static.prod-images.emergentagent.com/jobs/4093f316-5b76-4f43-8631-ea3db1f19db5/images/fdd7c877d85da5b49ba79d4238f187634cd3b4ff9adf7dd02034aa1a80c4a41e.png";

export const EXACT_LOGO = "https://static.prod-images.emergentagent.com/jobs/4093f316-5b76-4f43-8631-ea3db1f19db5/images/53bc4980a38017b366fd867f7fc7be84774d5aec125b2487589f80000550afd2.png";

export const ING_LOGO = "https://static.prod-images.emergentagent.com/jobs/4093f316-5b76-4f43-8631-ea3db1f19db5/images/0db077de2b3dbe87596daba8c6a40cbc90d888e329898bcc8db9f14052ef059d.png";

export const SHOPIFY_LOGO = "https://static.prod-images.emergentagent.com/jobs/4093f316-5b76-4f43-8631-ea3db1f19db5/images/16bc424156daf3a89422b8a0546480364e369aa5ffc2b0eaabf639c4d5396665.png";

export const TRUCKSHOP_LOGO = "https://static.prod-images.emergentagent.com/jobs/4093f316-5b76-4f43-8631-ea3db1f19db5/images/408f4311cf953ecce95851cf51c4146cb0e893e408ef531b108a27c541d6dafc.png";

export const TW1_LOGO = EXACT_LOGO;
